document.addEventListener('alpine:init', () => {
  Alpine.data("headerMenu", () => ({
    submenuOpen: false,
  }));

  Alpine.data("headerMenuItem", () => ({
    open: false,
    headerMenuItemChild: {
      ['x-init']() {
        this.$watch("open", (open) => {
          Alpine.store("submenuOpen", open);
          // Cancel any in-flight slide first, as in slide-toggle-container.js.
          // A fast hover in→out→in otherwise lets the hide's `finish` handler
          // set `display:none` after the show has started. $watch only fires
          // on change, so every call here reverses direction.
          this.$el.getAnimations().forEach((animation) => animation.cancel());
          if (open) {
            window.slideDown(this.$el);
          }
          else {
            window.slideUp(this.$el);
          }
        });
      }
    },
  }));

  Alpine.data("headerMobileMenuItem", () => ({
    open: false,
    headerMobileMenuItemChild: {
      ['x-init']() {
        // TODO: Tab focus trap on mobile menu. Parent, child
        const checkSubMenuOpen = (submenuOpenValue) => {
          setSectionTabindex(this.$el, submenuOpenValue ? '0' : '-1');
        };

        checkSubMenuOpen(false);

        this.$watch("open", (openValue) => {
          const subMenuItem = this.$el;
          Alpine.store("submenuOpen", openValue);
          subMenuItem.classList[openValue ? 'add' : 'remove']('-translate-x-full');

          checkSubMenuOpen(openValue);
        });

        this.$watch('$store.mobileMenuOpen', (mobileMenuOpenValue) => {
          if (!mobileMenuOpenValue) {
            this.$data.open = mobileMenuOpenValue;
          }
        })
      }
    }
  }));

  //Summenu hover card controller
  Alpine.data("headerSubMenu", () => ({
    neverHovered: true,
    lastItemHovered: false,
    headerSubMenuItemLink: {
      ["@focus"](e) {
        const closestListElement = e.target.parentNode;
        if (closestListElement.querySelectorAll(".menu-card").length) {
          this.lastItemHovered = closestListElement;
          this.neverHovered = false;

          // closestListElement.querySelectorAll(".menu-card");
        }
      }
    },
    headerSubMenuItem: {
      ["@mouseenter"](e) {
        const closestListElement = e.target;
        if (closestListElement.querySelectorAll(".menu-card").length) {
          this.lastItemHovered = closestListElement;
          this.neverHovered = false;
        }
      },
      [":class"]() {
        const isFirstSubmenuItem =
          Array.prototype.indexOf.call(
            this.$el.parentNode.children,
            this.$el
          ) == 0;

        const isLastItemHovered = this.$el == this.lastItemHovered;

        //If unhovered or last hovered, show children
        return (isFirstSubmenuItem && this.neverHovered) || isLastItemHovered
          ? "js-last-hovered"
          : "";
      },
    },
    menuCardGroup: {
    },
  }));
});
